import { defineComponent, ref, computed, watch, provide, reactive } from "vue";
import SvgIcon from "../SvgIcon.vue.mjs";
import ArrowStrokeSelectDownIcon from "../../icons/ArrowStrokeSelectDownIcon.vue.mjs";
import useZIndex from "../../../../hooks/useZIndex.mjs";
import "../../../../directives/vClickOutside.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SelectPC",
  props: {
    value: { type: [String, Number, Boolean, Object] },
    disabled: { type: Boolean },
    theme: null,
    customSelectContentStyle: null
  },
  emits: ["input", "change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const { nextZIndex } = useZIndex();
    const showSelectDropdown = ref(false);
    const optionArray = ref([]);
    const selectedLabel = ref("");
    const selectedValue = ref(props.value);
    const selectContainerRef = ref();
    const selectDropDownRef = ref();
    const dropDirection = ref("down");
    const themeClass = computed(
      () => props.theme ? `tui-theme-${props.theme}` : ""
    );
    watch(
      () => props.value,
      (val) => {
        selectedValue.value = val;
        const option = optionArray.value.find((item) => item.value === val);
        if (option) {
          selectedLabel.value = option.label;
        }
      }
    );
    watch(
      () => optionArray,
      () => {
        const option = optionArray.value.find((item) => item.value === props.value);
        if (option) {
          selectedLabel.value = option.label;
        }
      },
      { deep: true }
    );
    const dropDownStyle = ref({});
    function onOptionCreated(option) {
      optionArray.value.push(option);
    }
    function onOptionDestroyed(value) {
      const index = optionArray.value.findIndex((item) => item.value === value);
      optionArray.value.splice(index, 1);
    }
    function onOptionSelected(option) {
      selectedValue.value = option.value;
      showSelectDropdown.value = false;
      emits("input", option.value);
    }
    watch(selectedValue, (val) => {
      emits("change", val);
    });
    provide(
      "select",
      reactive({
        selectedValue,
        onOptionCreated,
        onOptionDestroyed,
        onOptionSelected
      })
    );
    function handleClickSelect() {
      if (props.disabled) {
        return;
      }
      if (showSelectDropdown.value) {
        showSelectDropdown.value = false;
      } else {
        handleDropDownPosition();
        dropDownStyle.value = { zIndex: nextZIndex() };
        showSelectDropdown.value = true;
        const option = optionArray.value.find((item) => item.value === props.value);
        option == null ? void 0 : option.ref.scrollIntoView({ block: "center" });
      }
    }
    function handleDropDownPosition() {
      var _a, _b;
      const { top, bottom } = ((_a = selectContainerRef.value) == null ? void 0 : _a.getBoundingClientRect()) || {};
      const bottomSize = document.body.offsetHeight - bottom;
      let dropDownContainerHeight = 0;
      if (!showSelectDropdown.value) {
        selectDropDownRef.value.style = "display:block;position:absolute;z-index:-1000";
        dropDownContainerHeight = selectDropDownRef.value.offsetHeight;
        selectDropDownRef.value.style = "";
      } else {
        dropDownContainerHeight = (_b = selectDropDownRef.value) == null ? void 0 : _b.offsetHeight;
      }
      if (bottomSize < top && bottomSize < dropDownContainerHeight) {
        dropDirection.value = "up";
      }
    }
    function handleClickOutside() {
      if (showSelectDropdown.value) {
        showSelectDropdown.value = false;
      }
    }
    return { __sfc: true, nextZIndex, props, emits, showSelectDropdown, optionArray, selectedLabel, selectedValue, selectContainerRef, selectDropDownRef, dropDirection, themeClass, dropDownStyle, onOptionCreated, onOptionDestroyed, onOptionSelected, handleClickSelect, handleDropDownPosition, handleClickOutside, SvgIcon, ArrowStrokeSelectDownIcon };
  }
});
export {
  _sfc_main as default
};
